import { Outlet } from "react-router-dom";
import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuthStore } from "../shared/store/auth.store";
import { hasStoredTokens } from "../shared/utils/storage";

export const RootLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useAuthStore();
  const navigationInProgress = useRef(false);

  useEffect(() => {
    if (navigationInProgress.current) return;

    // If authenticated and on login page, redirect to home
    if (isAuthenticated && location.pathname === "/login") {
      navigationInProgress.current = true;
      navigate("/devices", { replace: true });
      return;
    }

    // If tokens exist but store says not authenticated, restore auth state
    if (!isAuthenticated && location.pathname !== "/login") {
      if (hasStoredTokens()) {
        const { setAuthenticated } = useAuthStore.getState();
        setAuthenticated(true);
      }
    }
  }, [isAuthenticated, navigate, location.pathname]);

  return <Outlet />;
};
